var map = {
	"./abdomen.svg": 41009,
	"./arrow.svg": 74576,
	"./bassin.svg": 18865,
	"./cat.png": 30913,
	"./cheatsheet.png": 77879,
	"./demo-de.png": 23770,
	"./demo-en.png": 88546,
	"./demo-fr.png": 37267,
	"./fast-colors.svg": 13524,
	"./icon-download-white.svg": 86419,
	"./icon-images.svg": 4681,
	"./icon-radio-white.svg": 81236,
	"./icon-radio.svg": 36820,
	"./icon-radiosindatabase.svg": 42497,
	"./icon-report.svg": 54217,
	"./icon-vet.svg": 38864,
	"./icon-viewer.svg": 76445,
	"./icon-web-white.svg": 8347,
	"./logo-fas.png": 75105,
	"./logo-frontiers-in-veterinary-science.jpg": 41884,
	"./logo-veterinary-radiology.jpg": 17383,
	"./partners/logo-ger.png": 15829,
	"./partners/logo-languedocia.png": 58545,
	"./partners/logo-servive-portugal.png": 33250,
	"./picoxia-dark-grey.svg": 24039,
	"./thorax.svg": 89349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88532;